// extracted by mini-css-extract-plugin
module.exports = {"title":"RulePopIcon_title__7YxwW","desc":"RulePopIcon_desc__1ulxe"};